// quick-add.js (HARDENED: avoids crashing if ModalDialog missing / DOM pieces absent)
(function(){
  if (!window.customElements) return;
  if (typeof ModalDialog === 'undefined') {
    console.warn('quick-add: ModalDialog is not defined. Quick add disabled.');
    return;
  }
  if (!customElements.get('quick-add-modal')) {
    customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const _spinner = opener.querySelector('.loading-overlay__spinner');
        if (_spinner) _spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && window.Shopify.PaymentButton) window.Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.querySelector('product-form')?.setActiveElement(opener);
            this.querySelector('product-form')?.setActiveElement(opener);

            if (window.publish && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add-modal' });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            const _spinner2 = opener.querySelector('.loading-overlay__spinner');
            if (_spinner2) _spinner2.classList.add('hidden');
          });

        super.show(opener);
      }

      preventDuplicatedIDs() {
        const idElements = this.productElement.querySelectorAll('[id]');
        idElements.forEach((element) => {
          element.id = `quickadd-${element.id}`;
        });
      }

      removeDOMElements() {
        const selectors = [
          'pickup-availability',
          'product-modal',
          'product-recommendations',
          'complementary-products',
          'product-model'
        ];
        selectors.forEach((selector) => {
          this.productElement.querySelector(selector)?.remove();
        });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    });
  }
})();
